const SELECTORS = {
  swiperContainer: '.column-text__icon-wrap',
};

/**
 * Initialize swiper
 *
 * @param {object} Swiper swiper class object
 */
const initIconMenu = (Swiper) => {
  const swiperContainer = document.querySelector(SELECTORS.swiperContainer);

  const swiperOptions = {
    slidesPerView: 'auto',
    spaceBetween: 24,
    autoplay: false,
    allowSlideNext: true,
    allowSlidePrev: true,
  };
  if (swiperContainer) {
    // eslint-disable-next-line no-new
    new Swiper(swiperContainer, swiperOptions);
  }
};

document.addEventListener('DOMContentLoaded', () => {
  window.LoadSwiper.then((module) => {
    initIconMenu(module.Swiper);
  });

  const icons = document.querySelectorAll('.column-text__icon');
  const columnText = document.querySelectorAll('.column-text__column');
  const columnImg = document.querySelectorAll('.column-teaser__block');

  icons.forEach((icon) => {
    icon.addEventListener('click', () => {
      if (!icon.classList.contains('column-text__icon--active')) {
        const dataTab = icon.getAttribute('data-tab');
        document.querySelector('.column-text__icon--active').classList.remove('column-text__icon--active');
        document.querySelector(`.column-text__icon[data-tab=${dataTab}]`).classList.add('column-text__icon--active');
        columnText.forEach((text) => {
          if (text.classList.contains('column-text__column--active')) {
            text.classList.remove('column-text__column--active');
            text.classList.add('column-text__column--hidden');
          }
        });
        document.querySelector(`.column-text__column[data-tab=${dataTab}]`).classList.add('column-text__column--active');
        columnImg.forEach((img) => {
          if (img.classList.contains('column-teaser__block--active')) {
            img.classList.remove('column-teaser__block--active');
            img.classList.add('column-teaser__block--hidden');
          }
        });
        document.querySelector(`.column-teaser__block[data-tab=${dataTab}]`).classList.add('column-teaser__block--active');
      }
    });
  });
});
